var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 56,
    viewBox: "0 0 47 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_576_6197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8085 20.5268C36.8085 13.0664 30.7962 7 23.4062 7C16.0123 7 10 13.0664 10 20.5268C10 23.5485 10.9641 26.4055 12.7898 28.7877C12.8581 28.8796 19.7472 37.9485 21.7589 41.9813C22.0739 42.6132 22.704 43.0038 23.4024 43.0038C24.1008 43.0038 24.7308 42.6132 25.0459 41.9813C27.0234 38.0289 33.7265 29.1745 34.0111 28.7991L34.0187 28.7915C34.0453 28.757 34.0719 28.7264 34.0946 28.6919L34.7399 27.8417L34.7019 27.8149C36.0873 25.6357 36.8085 23.1425 36.8085 20.5268ZM23.4062 23.8166C21.311 23.8166 19.6105 22.1008 19.6105 19.9868C19.6105 17.8728 21.311 16.157 23.4062 16.157C25.5013 16.157 27.2018 17.8728 27.2018 19.9868C27.2018 22.1008 25.5013 23.8166 23.4062 23.8166Z",
    fill: "#FC3B22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_576_6197",
    x: 0,
    y: 0,
    width: 46.8086,
    height: 56.0039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.988235 0 0 0 0 0.231373 0 0 0 0 0.133333 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_576_6197"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_576_6197",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPoi);
export default __webpack_public_path__ + "static/media/icon_poi.c8df806729678c355bc6557215bb1512.svg";
export { ForwardRef as ReactComponent };